export default {
    computed: {
        optionsGender() {
            return [
                {
                    'value': 'M',
                    'label': this.$t('default.TitleM')
                },
                {
                    'value': 'F',
                    'label': this.$t('default.TitleV')
                },
            ];
        },
    }
}